/* Simbye Laenderblock — geteilt von den sechs land-* Sections.
   Guard: die Datei wird von jeder Section referenziert, der Browser
   laedt sie einmal, wuerde sie aber pro <script>-Tag erneut ausfuehren. */
if(!window.__sbLandInit){ window.__sbLandInit=1;
(function(){
  function txt(){ var l=(document.documentElement.lang||'de').slice(0,2);
    var m={de:['Mehr anzeigen','Weniger anzeigen'],en:['Show more','Show less'],fr:['Voir plus','Voir moins'],
      es:['Ver más','Ver menos'],it:['Mostra altro','Mostra meno'],nl:['Meer tonen','Minder tonen'],
      pl:['Pokaż więcej','Pokaż mniej'],pt:['Ver mais','Ver menos'],tr:['Daha fazla göster','Daha az göster'],
      ar:['عرض المزيد','عرض أقل'],ja:['もっと見る','閉じる'],ko:['더 보기','접기'],ru:['Показать ещё','Свернуть']};
    return m[l]||m.de; }
  function kuerzen(){
    if(window.innerWidth>640) return;
    var w=txt();
    document.querySelectorAll('.land-kurz').forEach(function(el){
      if(el.dataset.fertig) return;
      var n=parseInt(el.dataset.kurz||'4',10);
      var grenze;
      var fest=parseInt(el.dataset.fest||'0',10);
      if(fest){
        if(el.getBoundingClientRect().height <= fest+80){ el.dataset.fertig='1'; return; }
        grenze=fest;
      } else {
        var kinder=el.classList.contains('land-scroll') ? el.querySelectorAll('tbody tr') : el.children;
        if(kinder.length<=n+1) { el.dataset.fertig='1'; return; }
        grenze=kinder[n].getBoundingClientRect().top - el.getBoundingClientRect().top;
      }
      if(grenze<160){ el.dataset.fertig='1'; return; }
      el.style.maxHeight=Math.round(grenze)+'px';
      el.classList.add('zu');
      var b=document.createElement('button');
      b.className='land-mehr'; b.type='button'; b.textContent=w[0]; b.setAttribute('aria-expanded','false');
      b.addEventListener('click',function(){
        var zu=el.classList.toggle('zu');
        el.style.maxHeight = zu ? Math.round(grenze)+'px' : 'none';
        b.textContent = zu ? w[0] : w[1];
        b.setAttribute('aria-expanded', zu?'false':'true');
      });
      el.parentNode.insertBefore(b, el.nextSibling);
      el.dataset.fertig='1';
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',kuerzen);
  else kuerzen();
})();
}
